import { render } from "./widgets-side-menu-item-collapsed.vue?vue&type=template&id=e34b8dfc&scoped=true"
import script from "./widgets-side-menu-item-collapsed.vue?vue&type=script&setup=true&lang=js"
export * from "./widgets-side-menu-item-collapsed.vue?vue&type=script&setup=true&lang=js"

import "./widgets-side-menu-item-collapsed.vue?vue&type=style&index=0&id=e34b8dfc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e34b8dfc"],['__file',"src/components/card-component/widgets-side-menu-item-collapsed.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e34b8dfc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e34b8dfc', __exports__)) {
    api.reload('e34b8dfc', __exports__)
  }
  
  module.hot.accept("./widgets-side-menu-item-collapsed.vue?vue&type=template&id=e34b8dfc&scoped=true", () => {
    api.rerender('e34b8dfc', render)
  })

}


export default __exports__